// Configuración centralizada del menú
export const menuConfig = {
  sections: [
    // ── INTOCABLES ────────────────────────────────────────────────
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: 'LayoutDashboard',
      path: '/',
      type: 'single'
    },
    {
      id: 'yoolia',
      title: 'YOOLIA',
      icon: 'Yoolia',
      path: '/yoolia',
      type: 'single',
      external: false
    },
    {
      id: 'conversiones',
      title: 'Conversiones',
      icon: 'TrendingUp',
      type: 'group',
      expanded: false,
      items: [
        { id: 'conversiones-dashboard',      title: 'Dashboard',      path: '/conversiones',                       component: 'ConversionesDashboard' },
        { id: 'conversiones-vistas',         title: 'Vistas',         path: '/conversiones/vistas',                component: 'ConversionesVistas' },
        { id: 'conversiones-sesiones',       title: 'Sesiones',       path: '/conversiones/sesiones',              component: 'ConversionesSesiones' },
        { id: 'conversiones-simulaciones',   title: 'Simulaciones',   path: '/conversiones/simulaciones',          component: 'ConversionesSimulaciones' },
        { id: 'conversiones-contrataciones', title: 'Contrataciones', path: '/conversiones/contrataciones',        component: 'ConversionesContrataciones' },
        { id: 'conversiones-suscripciones',  title: 'Suscripciones',  path: '/conversiones/suscripciones',         component: 'ConversionesSuscripciones' },
        { id: 'conversiones-certificados',   title: 'Certificados',   path: '/conversiones/certificados',          component: 'ConversionesCertificados' }
      ]
    },

    // ── REORGANIZADOS ─────────────────────────────────────────────
    {
      id: 'clientes',
      title: 'Clientes',
      icon: 'Users',
      type: 'group',
      expanded: false,
      items: [
        { id: 'clientes-list',          title: 'Personas',                path: '/clientes',                           component: 'ClientesList' },
        { id: 'contratantes-list',      title: 'Contratantes',            path: '/contratantes',                       component: 'ContratantesList' },
        { id: 'contratantes-manager',   title: 'Gestión de Contratantes', path: '/contratantes/manager',               component: 'ContratantesManager' },
        { id: 'prospectos-freelancer',  title: 'Prospectos Freelancer',   path: '/conversiones/prospectos-freelancer', component: 'ProspectosFreelancerPage' },
        { id: 'empresas-planes',        title: 'Empresas',                path: '/product_config/empresas-planes',     component: 'EmpresasPlanesManager' }
      ]
    },
    {
      // Trazabilidad: el informe CMF y su rastro de accesos, juntos.
      // `Contratantes` aquí es el MISMO componente que en Clientes, con
      // mode="trazabilidad" (solo acciones de informe, sin gestión). Sigue
      // apareciendo en Clientes para el resto de tareas.
      id: 'trazabilidad',
      title: 'Trazabilidad',
      icon: 'ScrollText',
      type: 'group',
      expanded: false,
      items: [
        { id: 'trazabilidad-contratantes', title: 'Contratantes', path: '/trazabilidad/contratantes', component: 'ContratantesList' },
        // adminOnly es solo cosmético (oculta el ítem); la restricción real
        // está en /api/pdf/audit-log, que valida el rol del JWT de Clerk.
        { id: 'trazabilidad-auditoria',    title: 'Auditoría',    path: '/trazabilidad/auditoria',    component: 'AuditoriaList', adminOnly: true }
      ]
    },
    {
      id: 'seguros',
      title: 'Seguros',
      icon: 'Shield',
      type: 'group',
      expanded: false,
      items: [
        { id: 'certificates-list',    title: 'Certificados', path: '/certificates',        component: 'CertificatesList' },
        { id: 'emision-polizas',      title: 'Pólizas',      path: '/emision/polizas',     component: 'PolizasIndividualesList' },
        { id: 'emision-rendiciones',  title: 'Rendiciones',  path: '/emision/rendiciones', component: 'RendicionesPage' }
      ]
    },
    {
      id: 'pagos',
      title: 'Pagos',
      icon: 'CreditCard',
      type: 'group',
      expanded: false,
      items: [
        { id: 'payments-general',                title: 'Pagos Generales',         path: '/payments',                                  component: 'PaymentsList' },
        { id: 'orders',                          title: 'Órdenes de Pago',         path: '/ordenes-pago',                              component: 'OrdenespagoList' },
        { id: 'conciliacion-primas',             title: 'Conciliación de Primas',  path: '/payments/conciliacion',                     component: 'ConciliacionList' },
        { id: 'virtualpos-plans-list',           title: 'Planes VirtualPos',       path: '/payments-admin/virtualpos/planes',           component: 'VirtualPosPlansList' },
        { id: 'virtualpos-subscriptions-manager', title: 'Suscripciones VirtualPos', path: '/payments-admin/virtualpos/subscriptions', component: 'VirtualPosSubscriptionsList' },
        { id: 'subscription-charges',            title: 'Cargos de Suscripción',  path: '/payments-admin/cargos',                      component: 'SubscriptionChargesList' },
        { id: 'cron-logs',                       title: 'Cron Logs',               path: '/payments-admin/cron/logs',                   component: 'CronRunLogs' }
      ]
    },
    {
      id: 'yoolpay',
      title: 'YoolPay',
      icon: 'Banknote',
      type: 'group',
      expanded: false,
      // El ciclo de liquidación: Mes → Día. Tasas es una sección separada
      // (administración de fee_definitions que se leen en el cierre).
      items: [
        { id: 'yoolpay-mes', title: 'Mes', path: '/yoolpay/mes', component: 'YoolPayMes' },
        { id: 'yoolpay-dia', title: 'Día', path: '/yoolpay/dia', component: 'YoolPayDia' },
        { id: 'yoolpay-fees', title: 'Tasas', path: '/yoolpay/fees', component: 'YoolPayFeeDefinitionsList' }
      ]
    },
    {
      id: 'digital-wallet',
      title: 'Digital Wallet',
      icon: 'Smartphone',
      type: 'group',
      expanded: false,
      items: [
        { id: 'wallet-passes',       title: 'Passes',        path: '/wallet/passes',        component: 'WalletPasses' },
        { id: 'wallet-transmisiones', title: 'Transmisiones', path: '/wallet/transmisiones', component: 'WalletBroadcast' }
      ]
    },
    {
      id: 'product_config',
      title: 'Configuración productos',
      icon: 'Sparkles',
      type: 'group',
      expanded: false,
      items: [
        { id: 'product_config-productos', title: 'Productos', path: '/product_config/productos', component: 'DivinaProductos' },
        { id: 'product_config-planes',    title: 'Planes',    path: '/product_config/planes',    component: 'DivinaPlanes' }
      ]
    },
    {
      id: 'editorial',
      title: 'Editorial',
      icon: 'BookOpen',
      type: 'group',
      expanded: false,
      items: [
        { id: 'editorial-historias', title: 'Historias', path: '/editorial/historias', component: 'HistoriasList' }
      ]
    },
    {
      id: 'companies',
      title: 'Compañías',
      icon: 'Building2',
      type: 'group',
      expanded: false,
      items: [
        { id: 'companies-list',      title: 'Lista de Compañías',   path: '/companies',           component: 'CompaniesList' },
        { id: 'companies-dashboard', title: 'Dashboard Compañías',  path: '/companies/dashboard', component: 'CompanyDashboard' }
      ]
    },
    {
      id: 'colectivo',
      title: 'Colectivo',
      icon: 'Users2',
      type: 'group',
      expanded: false,
      items: [
        { id: 'polizas-colectivas',      title: 'Pólizas Colectivas',      path: '/product_config/polizas',      component: 'ColectivePolizasList' },
        { id: 'contratantes-colectivos', title: 'Contratantes Colectivos', path: '/product_config/contratantes', component: 'ContratantesColectivosList' }
      ]
    },
    {
      id: 'marketing',
      title: 'Marketing',
      icon: 'Megaphone',
      type: 'group',
      expanded: false,
      items: [
        { id: 'marketing-agent',                       title: 'Content Agent',               path: '/marketing/agent',                       component: 'ContentAgent' },
        { id: 'marketing-lead-qualifier',              title: 'Lead Qualifier',               path: '/marketing/lead-qualifier',              component: 'LeadQualifier' },
        { id: 'marketing-conversational-sales-agent',  title: 'Conversational Sales Agent',   path: '/marketing/conversational-sales-agent',  component: 'ConversationalSalesAgent' },
        { id: 'campanas-manage',                       title: 'Gestionar Campañas',           path: '/campanas',                              component: 'CampaignsList' },
        { id: 'campanas-single',                       title: 'Email Individual',             path: '/campanas/single',                       component: 'SingleMailForm' },
        { id: 'campanas-templates',                    title: 'Plantillas',                   path: '/campanas/templates',                    component: 'TemplatesList' },
        { id: 'campanas-contacts',                     title: 'Contactos',                    path: '/campanas/contacts',                     component: 'ContactsList' },
        { id: 'campanas-segments',                     title: 'Segmentos',                    path: '/campanas/segments',                     component: 'SegmentsList' },
        { id: 'instagram-insights',                    title: 'Instagram Insights',           path: '/socials/instagram/insights',            component: 'InstagramInsights' }
      ]
    },
    {
      id: 'conversaciones',
      title: 'Conversaciones',
      icon: 'MessageSquare',
      path: '/conversaciones',
      type: 'single'
    },
    {
      id: 'dev',
      title: 'Desarrollo',
      icon: 'Code2',
      type: 'group',
      expanded: false,
      items: [
        { id: 'dev-api-docs', title: 'API Docs', path: '/dev/api-docs', component: 'ApiDocsPage' }
      ]
    },
    {
      id: 'admin',
      title: 'Administración',
      icon: 'Settings',
      type: 'group',
      expanded: false,
      items: [
        { id: 'familias-list',  title: 'Familias',       path: '/admin/familias',    component: 'FamiliasList' },
        { id: 'ramos-list',     title: 'Ramos',          path: '/admin/ramos',       component: 'RamosList' },
        { id: 'urls-list',      title: 'URLs',           path: '/admin/urls',        component: 'UrlsList' },
        { id: 'uf-diaria-list', title: 'UF Diaria',      path: '/admin/uf-diaria',   component: 'UfDiariaList' },
        { id: 'pdf-templates',  title: 'Templates PDF',  path: '/pdf-templates',     type: 'single' },
        { id: 'oauth-consent',  title: 'OAuth Consent',  path: '/oauth/consent',     component: 'OAuthConsent' },
        { id: 'exportar',       title: 'Exportar',       path: '/exportar',          type: 'single' },
        { id: 'configuracion',  title: 'Configuración',  path: '/configuracion',     type: 'single' },
        { id: 'app-health',     title: 'App Health',     path: '/app-health',        type: 'single' }
      ]
    }
  ]
};

// Función helper para obtener todas las rutas planas
export const getAllRoutes = () => {
  const routes = [];

  menuConfig.sections.forEach(section => {
    if (section.type === 'single') {
      routes.push({
        path: section.path,
        component: section.component || section.id,
        title: section.title
      });
    } else if (section.type === 'group' && section.items) {
      section.items.forEach(item => {
        routes.push({
          path: item.path,
          component: item.component,
          title: item.title,
          parent: section.title
        });
      });
    }
  });

  return routes;
};

// Función helper para obtener rutas por sección
export const getRoutesBySection = (sectionId) => {
  const section = menuConfig.sections.find(s => s.id === sectionId);
  if (!section) return [];

  if (section.type === 'single') {
    return [{ path: section.path, component: section.component || section.id }];
  }

  return section.items || [];
};

// Función helper para obtener configuración del sidebar
let memoizedSidebarConfig = null;

export const getSidebarConfig = () => {
  if (!memoizedSidebarConfig) {
    memoizedSidebarConfig = menuConfig.sections.map(section => ({
      ...section,
      hasSubmenu: section.type === 'group' && section.items && section.items.length > 0
    }));
  }
  return memoizedSidebarConfig;
};
